<div class="client-history-container">

  <!-- ═══════════════ Breadcrumb ═══════════════ -->
  <nav class="crumb-bar">
    <a class="crumb-link" href="javascript:void(0)" (click)="backToClients()">
      Lex-Z Clients
    </a>
    <i class="bi bi-chevron-right crumb-sep"></i>
    <span class="crumb-current">
      {{ client?.name || 'Client' }}
      <span *ngIf="client?.coffer_id">({{ client?.coffer_id }})</span>
    </span>
  </nav>

  <div class="history-layout" [class.detail-open]="detailKind">

    <!-- ═══════════════════════════════════════════════════════
                          MAIN COLUMN
    ═══════════════════════════════════════════════════════ -->
    <div class="history-main">

      <!-- ── Client card ── -->
      <div class="client-card">

        <div class="client-identity">

          <div class="client-avatar">{{ initials(client?.name) }}</div>

          <div class="client-identity-text">

            <div class="client-name-row">
              <h5 class="client-name">{{ client?.name || '-' }}</h5>

              <span class="type-badge" *ngIf="client?.account_type">
                {{ client?.account_type === 'internal_test'
                    ? 'Test Account'
                    : (client?.account_type | titlecase) }}
              </span>
            </div>

            <div class="client-contact">
              <span class="contact-item" *ngIf="client?.email">
                <i class="bi bi-envelope"></i>
                <a [href]="'mailto:' + client?.email">{{ client?.email }}</a>
              </span>

              <span class="contact-item" *ngIf="client?.phone">
                <i class="bi bi-telephone"></i>
                <a [href]="'tel:' + client?.phone">{{ client?.phone }}</a>
              </span>
            </div>

          </div>

        </div>

        <div class="client-meta">

          <div class="meta-item">
            <span class="meta-label">Client ID</span>
            <span class="meta-value">{{ client?.coffer_id || '-' }}</span>
          </div>

          <div class="meta-item">
            <span class="meta-label">Registered On</span>
            <span class="meta-value">{{ formatDate(client?.registered_on) }}</span>
          </div>

          <div class="meta-item">
            <span class="meta-label">Last Login</span>
            <span class="meta-value">{{ formatDateTime(client?.last_login) }}</span>
          </div>

          <div class="meta-item">
            <span class="meta-label">Status</span>
            <span class="status-badge status-pill"
                  [ngClass]="(client?.status | lowercase) === 'active'
                              ? 'status-completed' : 'status-default'">
              {{ client?.status || '-' }}
            </span>
          </div>

        </div>

      </div>

      <!-- ── Summary cards ── -->
      <div class="summary-grid">

        <!-- Total Appointments -->
        <div class="summary-card">
          <div class="summary-top">
            <div class="summary-icon icon-blue">
              <i class="bi bi-calendar2-week"></i>
            </div>
            <div class="summary-text">
              <div class="summary-label">Total Appointments</div>
              <div class="summary-value">{{ summary?.appointments?.total || 0 }}</div>
            </div>
          </div>

          <div class="summary-foot">
            <span class="foot-item">
              Completed <strong>{{ summary?.appointments?.completed || 0 }}</strong>
            </span>
            <span class="foot-divider"></span>
            <span class="foot-item">
              Cancelled <strong>{{ summary?.appointments?.cancelled || 0 }}</strong>
            </span>
            <span class="foot-divider"></span>
            <span class="foot-item">
              Upcoming <strong>{{ summary?.appointments?.upcoming || 0 }}</strong>
            </span>
            <span class="foot-divider"></span>
            <span class="foot-item">
              Ongoing <strong>{{ summary?.appointments?.ongoing || 0 }}</strong>
            </span>
          </div>
        </div>

        <!-- Total Paid -->
        <div class="summary-card">
          <div class="summary-top">
            <div class="summary-icon icon-green">
              <i class="bi bi-currency-rupee"></i>
            </div>
            <div class="summary-text">
              <div class="summary-label">Total Paid</div>
              <div class="summary-value">
                {{ money(summary?.payments?.total_paid, summary?.currency) }}
              </div>
            </div>
          </div>

          <div class="summary-foot">
            <span class="foot-item">
              Successful Payments
              <strong>{{ summary?.payments?.successful_payments || 0 }}</strong>
            </span>
            <span class="foot-divider"></span>
            <span class="foot-item foot-muted">
              across
              {{ summary?.payments?.appointments || 0 }} appointments
            </span>
          </div>
        </div>

        <!-- Net Refunded -->
        <div class="summary-card">
          <div class="summary-top">
            <div class="summary-icon icon-orange">
              <i class="bi bi-arrow-counterclockwise"></i>
            </div>
            <div class="summary-text">
              <div class="summary-label">Net Refunded</div>
              <div class="summary-value">
                {{ money(summary?.refunds?.total_refunded, summary?.currency) }}
              </div>
            </div>
          </div>

          <div class="summary-foot">
            <span class="foot-item">
              Refunded Appointments
              <strong>{{ summary?.refunds?.refunded_appointments || 0 }}</strong>
              <span class="foot-muted">
                of {{ summary?.refunds?.total_appointments || 0 }}
              </span>
            </span>
            <span class="foot-divider"></span>
            <span class="foot-item foot-muted">Consultation fee only</span>
          </div>
        </div>

        <!-- Taxes & Platform Fee -->
        <div class="summary-card">
          <div class="summary-top">
            <div class="summary-icon icon-slate">
              <i class="bi bi-receipt-cutoff"></i>
            </div>
            <div class="summary-text">
              <div class="summary-label">Taxes &amp; Platform Fee</div>
              <div class="summary-value">
                {{ money(taxesAndFee, summary?.currency) }}
              </div>
            </div>
          </div>

          <div class="summary-foot">
            <span class="foot-item">
              Fee
              <strong>
                {{ money(summary?.consultation_charges?.platform_fee,
                         summary?.currency) }}
              </strong>
            </span>
            <span class="foot-divider"></span>
            <span class="foot-item">
              GST
              <strong>
                {{ money(summary?.consultation_charges?.tax, summary?.currency) }}
              </strong>
            </span>
            <span class="foot-divider"></span>
            <span class="foot-item foot-muted">
              across all
              {{ summary?.consultation_charges?.appointments || 0 }}
              appointments, not refunded
            </span>
          </div>
        </div>

      </div>

      <!-- ── Tabs + tab body ── -->
      <div class="tab-card">

        <div class="tab-bar">
          <button class="tab-btn"
                  [class.active]="activeTab === 'appointments'"
                  (click)="selectTab('appointments')">
            Appointments
          </button>

          <button class="tab-btn"
                  [class.active]="activeTab === 'payments'"
                  (click)="selectTab('payments')">
            Payments
          </button>

          <button class="tab-btn"
                  [class.active]="activeTab === 'refunds'"
                  (click)="selectTab('refunds')">
            Refunds
          </button>

          <button class="tab-btn"
                  [class.active]="activeTab === 'activity'"
                  (click)="selectTab('activity')">
            Activity
          </button>
        </div>

        <!-- ═══════════ Every tab shares this shell ═══════════ -->
        <div class="tab-body">

          <!-- Toolbar (shared; the active tab supplies its own state) -->
          <div class="tab-header">

            <h6 class="tab-title">
              {{ tabTitle }}
              <span class="count-badge">{{ state.pagination?.total || 0 }}</span>
            </h6>

            <div class="tab-tools">

              <!-- Date range -->
              <div class="tool-wrap" (click)="$event.stopPropagation()">
                <button class="tool-btn" (click)="toggleDateMenu($event)">
                  <i class="bi bi-calendar3"></i>
                  <span class="tool-text">{{ dateRangeLabel }}</span>
                  <i class="bi bi-chevron-down tool-caret"></i>
                </button>

                <div class="tool-menu" *ngIf="showDateMenu">
                  <div class="menu-title">Date range</div>

                  <label class="menu-label">From</label>
                  <input type="date" class="form-control" [(ngModel)]="state.draftStart">

                  <label class="menu-label">To</label>
                  <input type="date" class="form-control" [(ngModel)]="state.draftEnd">

                  <div class="menu-actions">
                    <button class="btn btn-link btn-clear" (click)="clearDateRange()">
                      Clear
                    </button>
                    <button class="btn btn-apply" (click)="applyDateRange()">
                      Apply
                    </button>
                  </div>
                </div>
              </div>

              <!-- Status / event type -->
              <div class="tool-wrap">
                <select class="tool-select"
                        [(ngModel)]="state.status"
                        (change)="onFilterChange()">
                  <option *ngFor="let option of statusOptionsForTab"
                          [value]="option.value">
                    {{ option.value ? option.label : statusPlaceholder }}
                  </option>
                </select>
              </div>

              <!-- Method (payments only) -->
              <div class="tool-wrap" *ngIf="activeTab === 'payments'">
                <select class="tool-select"
                        [(ngModel)]="pay.method"
                        (change)="onFilterChange()">
                  <option *ngFor="let option of methodOptions" [value]="option.value">
                    {{ option.value ? option.label : 'Method' }}
                  </option>
                </select>
              </div>

              <!-- Extra filters -->
              <div class="tool-wrap"
                   *ngIf="hasFilterMenu"
                   (click)="$event.stopPropagation()">
                <button class="tool-btn" (click)="toggleFilterMenu($event)">
                  <i class="bi bi-funnel"></i>
                  <span class="tool-text">Filter</span>
                  <span class="filter-count" *ngIf="activeFilterCount">
                    {{ activeFilterCount }}
                  </span>
                </button>

                <div class="tool-menu" *ngIf="showFilterMenu">

                  <!-- Appointments -->
                  <ng-container *ngIf="activeTab === 'appointments'">
                    <div class="menu-title">Filter appointments</div>

                    <label class="menu-label">Consultation mode</label>
                    <select class="form-select" [(ngModel)]="appt.draftMode">
                      <option *ngFor="let option of consultationModeOptions"
                              [value]="option.value">
                        {{ option.label }}
                      </option>
                    </select>

                    <label class="menu-label">Payment status</label>
                    <select class="form-select" [(ngModel)]="appt.draftPaymentStatus">
                      <option *ngFor="let option of paymentStatusOptions"
                              [value]="option.value">
                        {{ option.label }}
                      </option>
                    </select>
                  </ng-container>

                  <!-- Payments -->
                  <ng-container *ngIf="activeTab === 'payments'">
                    <div class="menu-title">Filter payments</div>

                    <label class="menu-label">Order or appointment id</label>
                    <input type="text"
                           class="form-control"
                           placeholder="Search by id"
                           [(ngModel)]="pay.draftSearch"
                           (keyup.enter)="applyFilters()">
                  </ng-container>

                  <!-- Refunds -->
                  <ng-container *ngIf="activeTab === 'refunds'">
                    <div class="menu-title">Filter refunds</div>

                    <label class="menu-label">Refund type</label>
                    <select class="form-select" [(ngModel)]="ref.draftRefundType">
                      <option *ngFor="let option of refundTypeOptions"
                              [value]="option.value">
                        {{ option.label }}
                      </option>
                    </select>

                    <label class="menu-label">Refund id</label>
                    <input type="text"
                           class="form-control"
                           placeholder="Search by id"
                           [(ngModel)]="ref.draftSearch"
                           (keyup.enter)="applyFilters()">
                  </ng-container>

                  <div class="menu-actions">
                    <button class="btn btn-link btn-clear" (click)="resetFilters()">
                      Reset
                    </button>
                    <button class="btn btn-apply" (click)="applyFilters()">
                      Apply
                    </button>
                  </div>
                </div>
              </div>

              <!-- Export (payments and refunds) -->
              <button class="btn-export"
                      *ngIf="canExport"
                      [disabled]="exporting || !state.rows.length"
                      (click)="exportRows()">
                <i class="bi" [ngClass]="exporting
                                          ? 'bi-arrow-repeat spin'
                                          : 'bi-download'"></i>
                {{ exporting ? 'Exporting…' : 'Export' }}
              </button>

            </div>

          </div>

          <!-- ── Appointments table ── -->
          <div class="history-table"
               *ngIf="activeTab === 'appointments' && !appt.loading && appt.rows.length > 0">

            <table class="table">

              <thead>
                <tr>
                  <th class="thdata">Date &amp; Time</th>
                  <th class="thdata">Appointment ID</th>
                  <th class="thdata">Lawyer</th>
                  <th class="thdata hide-md">Consultation</th>
                  <th class="thdata">Amount</th>
                  <th class="thdata">Status</th>
                </tr>
              </thead>

              <tbody>
                <tr class="row-link"
                    *ngFor="let row of appt.rows; trackBy: trackByAppointment"
                    [class.row-selected]="isSelected('appointment', row.appointment_id)"
                    (click)="openAppointment(row)"
                    tabindex="0"
                    (keyup.enter)="openAppointment(row)">

                  <td>
                    <div class="cell-strong">{{ formatDate(row.appointment_from) }}</div>
                    <div class="cell-sub">{{ formatTime(row.appointment_from) }}</div>
                  </td>

                  <td>
                    <span class="mono" [title]="row.appointment_id">
                      {{ row.appointment_id || '-' }}
                    </span>
                  </td>

                  <td>
                    <!-- <span class="dot"></span> -->
                    {{ row.lawyer?.name || '-' }}
                  </td>

                  <td class="hide-md">
                    <div class="cell-strong">{{ row.consultation_type || '-' }}</div>
                    <div class="cell-sub">{{ modeLabel(row.consultation_mode) }}</div>
                  </td>

                  <td>{{ money(row.amount, row.currency) }}</td>

                  <td>
                    <span class="status-badge" [ngClass]="statusClass(row.status)">
                      {{ statusLabel(row.status) }}
                    </span>
                  </td>

                </tr>
              </tbody>

            </table>

          </div>

          <!-- ── Payments table ── -->
          <div class="history-table"
               *ngIf="activeTab === 'payments' && !pay.loading && pay.rows.length > 0">

            <table class="table">

              <thead>
                <tr>
                  <th class="thdata">Payment Date</th>
                  <th class="thdata">Payment ID</th>
                  <th class="thdata">Appointment ID</th>
                  <th class="thdata">Lawyer</th>
                  <th class="thdata">Amount</th>
                  <th class="thdata hide-md">Method</th>
                  <th class="thdata">Status</th>
                  <th class="thdata hide-lg">Razorpay Order ID</th>
                </tr>
              </thead>

              <tbody>
                <tr class="row-link"
                    *ngFor="let row of pay.rows; trackBy: trackByPayment"
                    [class.row-selected]="isSelected('payment', row.order_id)"
                    (click)="openPayment(row)"
                    tabindex="0"
                    (keyup.enter)="openPayment(row)">

                  <td>
                    <div class="cell-strong">{{ formatDate(row.payment_date) }}</div>
                    <div class="cell-sub">{{ formatTime(row.payment_date) }}</div>
                  </td>

                  <td>
                    <span class="mono" [title]="row.payment_id || ''">
                      {{ row.payment_id || '-' }}
                    </span>
                  </td>

                  <td>
                    <span class="mono" [title]="row.appointment_id || ''">
                      {{ row.appointment_id || '-' }}
                    </span>
                  </td>

                  <td>{{ row.lawyer?.name || '-' }}</td>

                  <td>{{ money(row.amount, row.currency) }}</td>

                  <td class="hide-md">{{ modeLabel(row.method) }}</td>

                  <td>
                    <span class="status-badge" [ngClass]="paymentStatusClass(row.status)">
                      {{ statusLabel(row.status) }}
                    </span>
                  </td>

                  <td class="hide-lg">
                    <span class="mono" [title]="row.razorpay_order_id || ''">
                      {{ row.razorpay_order_id || '-' }}
                    </span>
                  </td>

                </tr>
              </tbody>

            </table>

          </div>

          <!-- ── Refunds table ── -->
          <div class="history-table"
               *ngIf="activeTab === 'refunds' && !ref.loading && ref.rows.length > 0">

            <table class="table">

              <thead>
                <tr>
                  <th class="thdata">Refund Date</th>
                  <th class="thdata">Refund ID</th>
                  <th class="thdata">Appointment ID</th>
                  <th class="thdata">Lawyer</th>
                  <th class="thdata hide-lg">Original Payment</th>
                  <th class="thdata">Refund Amount</th>
                  <th class="thdata hide-md">Reason</th>
                  <th class="thdata">Status</th>
                </tr>
              </thead>

              <tbody>
                <tr class="row-link"
                    *ngFor="let row of ref.rows; trackBy: trackByRefund"
                    [class.row-selected]="isSelected('refund', row.refund_id)"
                    (click)="openRefund(row)"
                    tabindex="0"
                    (keyup.enter)="openRefund(row)">

                  <td>
                    <div class="cell-strong">{{ formatDate(row.refund_date) }}</div>
                    <div class="cell-sub">{{ formatTime(row.refund_date) }}</div>
                  </td>

                  <td>
                    <span class="mono" [title]="row.razorpay_refund_id || row.refund_id">
                      {{ row.razorpay_refund_id || row.refund_id || '-' }}
                    </span>
                  </td>

                  <td>
                    <span class="mono" [title]="row.appointment_id || ''">
                      {{ row.appointment_id || '-' }}
                    </span>
                  </td>

                  <td>
                    <!-- <span class="dot"></span> -->
                    {{ row.lawyer?.name || '-' }}
                  </td>

                  <td class="hide-lg">
                    {{ money(row.original_payment, row.currency) }}
                  </td>

                  <td class="cell-strong">{{ money(row.amount, row.currency) }}</td>

                  <td class="hide-md reason-cell">{{ row.reason || '-' }}</td>

                  <td>
                    <span class="status-badge" [ngClass]="paymentStatusClass(row.status)">
                      {{ statusLabel(row.status) }}
                    </span>
                  </td>

                </tr>
              </tbody>

            </table>

          </div>

          <!-- ── Activity timeline ── -->
          <ng-container
            *ngIf="activeTab === 'activity' && !act.loading && act.rows.length > 0">

            <p class="tab-subtitle">
              Complete timeline of all activities related to this client.
            </p>

            <div class="activity-list">

              <div class="activity-row"
                   *ngFor="let row of act.rows; trackBy: trackByActivity"
                   [class.row-selected]="isSelected('activity', row.event_id)"
                   (click)="openActivity(row)"
                   tabindex="0"
                   (keyup.enter)="openActivity(row)">

                <span class="activity-icon" [ngClass]="activityTone(row.type)">
                  <i class="bi" [ngClass]="activityIcon(row.type)"></i>
                </span>

                <div class="activity-text">
                  <div class="activity-title">{{ row.title }}</div>
                  <div class="activity-desc">{{ row.description || '-' }}</div>
                </div>

                <div class="activity-when">
                  <div class="activity-time">{{ formatDateTime(row.timestamp) }}</div>
                  <div class="activity-actor">{{ row.performed_by || 'System' }}</div>
                </div>

              </div>

            </div>

          </ng-container>

          <!-- Skeleton -->
          <div class="skeleton-wrapper" *ngIf="state.loading">
            <div class="skeleton-row" *ngFor="let row of [1,2,3,4,5,6]">
              <div class="skeleton-cell wide"></div>
              <div class="skeleton-cell medium"></div>
              <div class="skeleton-cell medium"></div>
              <div class="skeleton-cell wide hide-md"></div>
              <div class="skeleton-cell small"></div>
              <div class="skeleton-cell medium"></div>
            </div>
          </div>

          <!-- Empty -->
          <div class="empty-state" *ngIf="!state.loading && state.rows.length === 0">
            <i class="bi empty-icon"
               [ngClass]="{
                 'bi-calendar-x': activeTab === 'appointments',
                 'bi-receipt': activeTab === 'payments',
                 'bi-arrow-counterclockwise': activeTab === 'refunds',
                 'bi-clock-history': activeTab === 'activity'
               }"></i>
            <p class="empty-title">No {{ rowNoun }} found</p>
            <p class="empty-sub">
              Try widening the date range or clearing the filters.
            </p>
          </div>

          <!-- Pagination -->
          <div class="pagination-area" *ngIf="!state.loading && state.rows.length > 0">

            <div class="pagination-info">{{ getPaginationRange() }}</div>

            <div class="pagination-controls">

              <nav>
                <ul class="pagination mb-0">

                  <li class="page-item"
                      [ngClass]="{'disabled': state.pagination.page <= 1}">
                    <a class="page-link" href="javascript:void(0)"
                       (click)="goToPrevPage()">
                      <i class="bi bi-chevron-left"></i>
                    </a>
                  </li>

                  <li class="page-item"
                      *ngFor="let page of getPageNumbers()"
                      [ngClass]="{'active': page === state.pagination.page}">
                    <a class="page-link" href="javascript:void(0)"
                       (click)="goToPage(page)">{{ page }}</a>
                  </li>

                  <li class="page-item"
                      [ngClass]="{'disabled': state.pagination.page >= getTotalPages()}">
                    <a class="page-link" href="javascript:void(0)"
                       (click)="goToNextPage()">
                      <i class="bi bi-chevron-right"></i>
                    </a>
                  </li>

                </ul>
              </nav>

              <select class="page-size"
                      [ngModel]="state.pagination.limit"
                      (ngModelChange)="changePageSize($event)">
                <option *ngFor="let size of pageSizeOptions" [ngValue]="size">
                  {{ size }} / page
                </option>
              </select>

            </div>

          </div>

          <!-- Load more (activity only) -->
          <div class="load-more-area" *ngIf="canLoadMore">
            <button class="btn-load-more"
                    [disabled]="act.loadingMore"
                    (click)="loadActivity(true)">
              {{ act.loadingMore ? 'Loading…' : 'Load More Activities' }}
            </button>
          </div>

        </div>

      </div>

    </div>

    <!-- ═══════════════════════════════════════════════════════
                        DETAIL PANEL
    ═══════════════════════════════════════════════════════ -->
    <div class="detail-backdrop" *ngIf="detailKind" (click)="closeDetail()"></div>

    <aside class="detail-panel" *ngIf="detailKind">

      <div class="detail-header">
        <h6 class="detail-title">
          {{ detailKind === 'payment' ? 'Payment Details'
             : detailKind === 'refund' ? 'Refund Details'
             : detailKind === 'activity' ? 'Activity Details'
             : 'Appointment Details' }}
        </h6>
        <button class="detail-close" (click)="closeDetail()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- ── Appointment detail ── -->
      <div class="detail-body"
           *ngIf="!detailLoading && detail && detailKind === 'appointment'">

        <div class="detail-head">

          <div class="detail-head-row">
            <span class="detail-id" [title]="detail.appointment?.appointment_id">
              {{ detail.appointment?.appointment_id || '-' }}
            </span>

            <span class="status-badge"
                  [ngClass]="statusClass(detail.appointment?.status)">
              {{ statusLabel(detail.appointment?.status) }}
            </span>
          </div>

          <div class="detail-head-meta">

            <div class="head-meta-item">
              <i class="bi bi-calendar3"></i>
              <div>
                <div class="cell-strong">
                  {{ formatDate(detail.appointment?.appointment_from) }}
                </div>
                <div class="cell-sub">
                  {{ formatTime(detail.appointment?.appointment_from) }}
                  <span *ngIf="detail.appointment?.appointment_to">
                    - {{ formatTime(detail.appointment?.appointment_to) }}
                  </span>
                  <span *ngIf="detail.appointment?.duration_minutes">
                    ({{ detail.appointment?.duration_minutes }}m)
                  </span>
                </div>
              </div>
            </div>

            <div class="head-meta-item">
              <i class="bi" [ngClass]="modeIcon(detail.appointment?.consultation_mode)"></i>
              <div>
                <div class="cell-strong">
                  {{ modeLabel(detail.appointment?.consultation_mode) }}
                </div>
                <div class="cell-sub">
                  {{ detail.appointment?.consultation_type || '-' }}
                </div>
              </div>
            </div>

            <div class="head-meta-item">
              <i class="bi bi-currency-rupee"></i>
              <div>
                <div class="cell-sub">Consultation Fee</div>
                <div class="cell-strong">
                  {{ money(detail.appointment?.consultation_fee,
                           detail.appointment?.currency) }}
                </div>
              </div>
            </div>

          </div>

        </div>

        <div class="detail-section">
          <div class="section-title">Client</div>

          <div class="party-row">
            <div class="party-icon"><i class="bi bi-person"></i></div>
            <div class="party-text">
              <div class="cell-strong">{{ detail.client?.name || '-' }}</div>
              <div class="cell-sub">
                <span *ngIf="detail.client?.email">{{ detail.client?.email }}</span>
                <span *ngIf="detail.client?.phone"> &nbsp;|&nbsp; {{ detail.client?.phone }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="detail-section">
          <div class="section-title">Lawyer</div>

          <div class="party-row">
            <div class="party-icon"><i class="bi bi-person-badge"></i></div>
            <div class="party-text">
              <div class="cell-strong">{{ detail.lawyer?.name || '-' }}</div>
              <div class="cell-sub">
                <span *ngIf="detail.lawyer?.email">{{ detail.lawyer?.email }}</span>
                <span *ngIf="detail.lawyer?.phone"> &nbsp;|&nbsp; {{ detail.lawyer?.phone }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="detail-section">
          <div class="section-head">
            <div class="section-title">Payment Information</div>
            <span class="status-badge"
                  [ngClass]="paymentStatusClass(detail.payment?.status)"
                  *ngIf="detail.payment">
              {{ statusLabel(detail.payment?.status) }}
            </span>
            <span class="status-badge status-default" *ngIf="!detail.payment">
              No Payment
            </span>
          </div>

          <div class="detail-grid" *ngIf="detail.payment">
            <div class="grid-item">
              <span class="grid-label">Payment ID</span>
              <span class="grid-value mono">
                {{ detail.payment?.razorpay_payment_id || detail.payment?.payment_id || '-' }}
              </span>
            </div>

            <div class="grid-item">
              <span class="grid-label">Payment Date</span>
              <span class="grid-value">{{ formatDateTime(detail.payment?.paid_at) }}</span>
            </div>

            <div class="grid-item">
              <span class="grid-label">Amount</span>
              <span class="grid-value">
                {{ money(detail.payment?.amount, detail.payment?.currency) }}
              </span>
            </div>

            <div class="grid-item">
              <span class="grid-label">Method</span>
              <span class="grid-value">{{ modeLabel(detail.payment?.method) }}</span>
            </div>

            <div class="grid-item">
              <span class="grid-label">Razorpay Order ID</span>
              <span class="grid-value mono">
                {{ detail.payment?.razorpay_order_id || '-' }}
              </span>
            </div>

            <div class="grid-item">
              <span class="grid-label">Razorpay Payment ID</span>
              <span class="grid-value mono">
                {{ detail.payment?.razorpay_payment_id || '-' }}
              </span>
            </div>

            <div class="grid-item" *ngIf="detail.invoice">
              <span class="grid-label">Invoice Number</span>
              <span class="grid-value mono">
                {{ detail.invoice?.invoice_number || '-' }}
              </span>
            </div>

            <div class="grid-item" *ngIf="detail.invoice">
              <span class="grid-label">Invoice ID</span>
              <span class="grid-value mono">{{ detail.invoice?.invoice_id }}</span>
            </div>
          </div>

          <a class="section-link"
             *ngIf="detail.invoice?.invoice_url"
             [href]="detail.invoice?.invoice_url"
             target="_blank"
             rel="noopener">
            <i class="bi bi-file-earmark-pdf"></i> View Payment Invoice
          </a>

          <p class="section-empty"
             *ngIf="detail.invoice && !detail.invoice?.invoice_url">
            The invoice PDF is still being generated.
          </p>

          <p class="section-empty" *ngIf="!detail.payment">
            No payment recorded for this appointment.
          </p>
        </div>

        <div class="detail-section">
          <div class="section-head">
            <div class="section-title">Refund Information</div>
            <span class="status-badge"
                  [ngClass]="paymentStatusClass(detail.refund?.status)"
                  *ngIf="detail.refund">
              {{ statusLabel(detail.refund?.status) }}
            </span>
            <span class="status-badge status-default" *ngIf="!detail.refund">
              No Refund
            </span>
          </div>

          <div class="detail-grid" *ngIf="detail.refund">
            <div class="grid-item">
              <span class="grid-label">Refund ID</span>
              <span class="grid-value mono">
                {{ detail.refund?.razorpay_refund_id || detail.refund?.refund_id || '-' }}
              </span>
            </div>

            <div class="grid-item">
              <span class="grid-label">Amount</span>
              <span class="grid-value">
                {{ money(detail.refund?.amount, detail.refund?.currency) }}
              </span>
            </div>

            <div class="grid-item">
              <span class="grid-label">Initiated On</span>
              <span class="grid-value">{{ formatDateTime(detail.refund?.initiated_at) }}</span>
            </div>

            <div class="grid-item">
              <span class="grid-label">Processed On</span>
              <span class="grid-value">{{ formatDateTime(detail.refund?.processed_at) }}</span>
            </div>

            <div class="grid-item grid-wide" *ngIf="detail.refund?.reason">
              <span class="grid-label">Reason</span>
              <span class="grid-value">{{ detail.refund?.reason }}</span>
            </div>
          </div>

          <p class="section-empty" *ngIf="!detail.refund">
            No refund issued for this appointment.
          </p>
        </div>

        <div class="detail-section">
          <div class="section-head">
            <div class="section-title">Settlement Information</div>
            <span class="status-badge"
                  *ngIf="hasSettlement"
                  [ngClass]="paymentStatusClass(detail.settlement?.payout_status
                                                || detail.settlement?.status)">
              {{ statusLabel(detail.settlement?.payout_status
                             || detail.settlement?.status) }}
            </span>
            <span class="status-badge status-default" *ngIf="!hasSettlement">
              Not Settled
            </span>
          </div>

          <p class="section-empty" *ngIf="!hasSettlement">
            No settlement raised for this appointment yet.
          </p>

          <div class="detail-grid" *ngIf="hasSettlement">
            <div class="grid-item">
              <span class="grid-label">Settlement Invoice</span>
              <span class="grid-value mono">
                {{ detail.settlement?.invoice_code || '-' }}
              </span>
            </div>

            <div class="grid-item">
              <span class="grid-label">Net Payable</span>
              <span class="grid-value">
                {{ money(detail.settlement?.net_payable, detail.settlement?.currency) }}
              </span>
            </div>

            <div class="grid-item">
              <span class="grid-label">Payout ID</span>
              <span class="grid-value mono">
                {{ detail.settlement?.razorpay_payout_id
                   || detail.settlement?.payout_id || '-' }}
              </span>
            </div>

            <div class="grid-item">
              <span class="grid-label">Payout Status</span>
              <span class="grid-value">
                {{ statusLabel(detail.settlement?.payout_status) }}
              </span>
            </div>

            <div class="grid-item" *ngIf="detail.settlement?.utr">
              <span class="grid-label">UTR</span>
              <span class="grid-value mono">{{ detail.settlement?.utr }}</span>
            </div>

            <div class="grid-item" *ngIf="detail.settlement?.completed_at">
              <span class="grid-label">Settled On</span>
              <span class="grid-value">
                {{ formatDateTime(detail.settlement?.completed_at) }}
              </span>
            </div>
          </div>

          <a class="section-link"
             *ngIf="hasSettlement && detail.settlement?.invoice_url"
             [href]="detail.settlement?.invoice_url"
             target="_blank"
             rel="noopener">
            <i class="bi bi-eye"></i> View Settlement Invoice
          </a>
        </div>

        <div class="detail-section">
          <div class="section-title">Appointment Timeline</div>

          <div class="timeline" *ngIf="detail.timeline?.length">
            <div class="timeline-item" *ngFor="let event of detail.timeline">
              <i class="bi" [ngClass]="timelineIcon(event.type)"></i>
              <span class="timeline-title">{{ event.title }}</span>
              <span class="timeline-time">{{ formatDateTime(event.timestamp) }}</span>
            </div>
          </div>

          <p class="section-empty" *ngIf="!detail.timeline?.length">
            No timeline events recorded.
          </p>
        </div>

      </div>

      <!-- ── Payment detail ── -->
      <div class="detail-body"
           *ngIf="!detailLoading && detail && detailKind === 'payment'">

        <div class="detail-head-row">
          <span class="detail-id" [title]="detail.payment_id || detail.order_id">
            {{ detail.payment_id || detail.order_id || '-' }}
          </span>

          <span class="status-badge" [ngClass]="paymentStatusClass(detail.status)">
            {{ statusLabel(detail.status) }}
          </span>
        </div>

        <div class="detail-section">
          <div class="section-title">Payment Information</div>

          <div class="detail-rows">

            <div class="row-item">
              <span class="row-label">Payment ID</span>
              <span class="row-value mono">{{ detail.payment_id || '-' }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Appointment ID</span>
              <span class="row-value mono" [title]="detail.appointment_id || ''">
                {{ detail.appointment_id || '-' }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Client</span>
              <span class="row-value">{{ detail.client?.name || '-' }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Lawyer</span>
              <span class="row-value">{{ detail.lawyer?.name || '-' }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Amount</span>
              <span class="row-value">{{ money(detail.amount, detail.currency) }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Payment Method</span>
              <span class="row-value">{{ modeLabel(detail.method) }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Payment Status</span>
              <span class="status-badge" [ngClass]="paymentStatusClass(detail.status)">
                {{ statusLabel(detail.status) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Created At</span>
              <span class="row-value">{{ formatDateTime(detail.created_at) }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Paid At</span>
              <span class="row-value">{{ formatDateTime(detail.paid_at) }}</span>
            </div>

          </div>
        </div>

        <div class="detail-section">
          <div class="section-title">Razorpay Information</div>

          <div class="detail-rows">

            <div class="row-item">
              <span class="row-label">Razorpay Order ID</span>
              <span class="row-value mono copy-value">
                {{ detail.razorpay_order_id || '-' }}
                <button class="copy-btn"
                        *ngIf="detail.razorpay_order_id"
                        title="Copy order id"
                        (click)="copy(detail.razorpay_order_id, 'Order ID')">
                  <i class="bi bi-clipboard"></i>
                </button>
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Razorpay Payment ID</span>
              <span class="row-value mono copy-value">
                {{ detail.razorpay_payment_id || '-' }}
                <button class="copy-btn"
                        *ngIf="detail.razorpay_payment_id"
                        title="Copy payment id"
                        (click)="copy(detail.razorpay_payment_id, 'Payment ID')">
                  <i class="bi bi-clipboard"></i>
                </button>
              </span>
            </div>

          </div>
        </div>

        <div class="detail-section">
          <div class="section-title">Additional Information</div>

          <div class="detail-rows">

            <div class="row-item">
              <span class="row-label">Currency</span>
              <span class="row-value">{{ detail.currency || '-' }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Order ID</span>
              <span class="row-value mono" [title]="detail.order_id">
                {{ detail.order_id || '-' }}
              </span>
            </div>

          </div>
        </div>

        <div class="detail-section" *ngIf="detail.invoice">
          <div class="section-head">
            <div class="section-title">Invoice</div>
            <span class="status-badge"
                  [ngClass]="paymentStatusClass(detail.invoice?.status)">
              {{ statusLabel(detail.invoice?.status) }}
            </span>
          </div>

          <div class="detail-rows">

            <div class="row-item">
              <span class="row-label">Invoice Number</span>
              <span class="row-value mono copy-value">
                {{ detail.invoice?.invoice_number || '-' }}
                <button class="copy-btn"
                        *ngIf="detail.invoice?.invoice_number"
                        title="Copy invoice number"
                        (click)="copy(detail.invoice?.invoice_number, 'Invoice number')">
                  <i class="bi bi-clipboard"></i>
                </button>
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Invoice ID</span>
              <span class="row-value mono">{{ detail.invoice?.invoice_id }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Invoice Amount</span>
              <span class="row-value">
                {{ money(detail.invoice?.amount, detail.invoice?.currency) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Issued On</span>
              <span class="row-value">
                {{ formatDateTime(detail.invoice?.issued_at) }}
              </span>
            </div>

          </div>

          <div class="invoice-actions" *ngIf="detail.invoice?.invoice_url">
            <a class="section-link"
               [href]="detail.invoice?.invoice_url"
               target="_blank"
               rel="noopener">
              <i class="bi bi-eye"></i> View Invoice
            </a>

            <a class="section-link"
               [href]="detail.invoice?.invoice_url"
               target="_blank"
               rel="noopener"
               download>
              <i class="bi bi-download"></i> Download
            </a>
          </div>

          <p class="section-empty" *ngIf="!detail.invoice?.invoice_url">
            The invoice PDF is still being generated.
          </p>
        </div>

        <button class="section-link section-link-btn"
                *ngIf="detail.appointment_id"
                (click)="viewRelatedAppointment()">
          <i class="bi bi-eye"></i> View Related Appointment
        </button>

      </div>

      <!-- ── Refund detail ── -->
      <div class="detail-body"
           *ngIf="!detailLoading && detail && detailKind === 'refund'">

        <div class="detail-head-row">
          <span class="detail-id"
                [title]="detail.razorpay_refund_id || detail.refund_id">
            {{ detail.razorpay_refund_id || detail.refund_id || '-' }}
          </span>

          <span class="status-badge" [ngClass]="paymentStatusClass(detail.status)">
            {{ statusLabel(detail.status) }}
          </span>
        </div>

        <div class="detail-section">
          <div class="section-title">Refund Information</div>

          <div class="detail-rows">

            <div class="row-item">
              <span class="row-label">Refund ID</span>
              <span class="row-value mono" [title]="detail.refund_id">
                {{ detail.razorpay_refund_id || detail.refund_id || '-' }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Appointment ID</span>
              <span class="row-value mono" [title]="detail.appointment_id || ''">
                {{ detail.appointment_id || '-' }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Refund Date</span>
              <span class="row-value">{{ formatDateTime(detail.initiated_at) }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Refund Status</span>
              <span class="status-badge" [ngClass]="paymentStatusClass(detail.status)">
                {{ statusLabel(detail.status) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Refund Type</span>
              <span class="row-value">{{ statusLabel(detail.refund_type) }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Refund Amount</span>
              <span class="row-value">
                {{ money(detail.amount, detail.currency) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Reason</span>
              <span class="row-value">{{ detail.reason || '-' }}</span>
            </div>

          </div>
        </div>

        <div class="detail-section">
          <div class="section-title">Payment Information</div>

          <div class="detail-rows">

            <div class="row-item">
              <span class="row-label">Payment ID</span>
              <span class="row-value mono copy-value">
                {{ detail.payment?.payment_id || '-' }}
                <button class="copy-btn"
                        *ngIf="detail.payment?.payment_id"
                        title="Copy payment id"
                        (click)="copy(detail.payment?.payment_id, 'Payment ID')">
                  <i class="bi bi-clipboard"></i>
                </button>
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Payment Date</span>
              <span class="row-value">
                {{ formatDateTime(detail.payment?.paid_at) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Original Payment Amount</span>
              <span class="row-value">
                {{ money(detail.payment?.original_amount, detail.currency) }}
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Payment Method</span>
              <span class="row-value">{{ modeLabel(detail.payment?.method) }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Razorpay Order ID</span>
              <span class="row-value mono copy-value">
                {{ detail.payment?.razorpay_order_id || '-' }}
                <button class="copy-btn"
                        *ngIf="detail.payment?.razorpay_order_id"
                        title="Copy order id"
                        (click)="copy(detail.payment?.razorpay_order_id, 'Order ID')">
                  <i class="bi bi-clipboard"></i>
                </button>
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Razorpay Payment ID</span>
              <span class="row-value mono copy-value">
                {{ detail.payment?.razorpay_payment_id || '-' }}
                <button class="copy-btn"
                        *ngIf="detail.payment?.razorpay_payment_id"
                        title="Copy payment id"
                        (click)="copy(detail.payment?.razorpay_payment_id, 'Payment ID')">
                  <i class="bi bi-clipboard"></i>
                </button>
              </span>
            </div>

          </div>
        </div>

        <div class="detail-section">
          <div class="section-title">Refund Gateway Information</div>

          <div class="detail-rows">

            <div class="row-item">
              <span class="row-label">Razorpay Refund ID</span>
              <span class="row-value mono copy-value">
                {{ detail.razorpay_refund_id || '-' }}
                <button class="copy-btn"
                        *ngIf="detail.razorpay_refund_id"
                        title="Copy refund id"
                        (click)="copy(detail.razorpay_refund_id, 'Refund ID')">
                  <i class="bi bi-clipboard"></i>
                </button>
              </span>
            </div>

            <div class="row-item">
              <span class="row-label">Refund Initiated At</span>
              <span class="row-value">{{ formatDateTime(detail.initiated_at) }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Refund Completed At</span>
              <span class="row-value">{{ formatDateTime(detail.completed_at) }}</span>
            </div>

          </div>
        </div>

        <button class="section-link section-link-btn"
                *ngIf="detail.appointment_id"
                (click)="viewRelatedAppointment()">
          <i class="bi bi-eye"></i> View Related Appointment
        </button>

      </div>

      <!-- ── Activity detail ── -->
      <div class="detail-body"
           *ngIf="!detailLoading && detail && detailKind === 'activity'">

        <div class="activity-head">
          <span class="activity-icon activity-icon-lg"
                [ngClass]="activityTone(detail.type)">
            <i class="bi" [ngClass]="activityIcon(detail.type)"></i>
          </span>
          <div>
            <div class="activity-head-title">{{ detail.title }}</div>
            <div class="cell-sub">{{ formatDateTime(detail.timestamp) }}</div>
          </div>
        </div>

        <div class="detail-section">
          <div class="section-title">Overview</div>

          <div class="detail-rows">

            <div class="row-item">
              <span class="row-label">Event Type</span>
              <span class="row-value">{{ detail.title }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Description</span>
              <span class="row-value">{{ detail.description || '-' }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Performed By</span>
              <span class="row-value">{{ detail.performed_by || 'System' }}</span>
            </div>

            <div class="row-item">
              <span class="row-label">Occurred At</span>
              <span class="row-value">{{ formatDateTime(detail.timestamp) }}</span>
            </div>

          </div>
        </div>

        <div class="detail-section"
             *ngIf="detail.payment_id || detail.appointment_id
                    || detail.lawyer?.name || detail.amount || detail.method">
          <div class="section-title">Related Information</div>

          <div class="detail-rows">

            <div class="row-item" *ngIf="detail.payment_id">
              <span class="row-label">Payment ID</span>
              <span class="row-value mono copy-value">
                {{ detail.payment_id }}
                <button class="copy-btn"
                        title="Copy payment id"
                        (click)="copy(detail.payment_id, 'Payment ID')">
                  <i class="bi bi-clipboard"></i>
                </button>
              </span>
            </div>

            <div class="row-item" *ngIf="detail.appointment_id">
              <span class="row-label">Appointment ID</span>
              <span class="row-value mono copy-value" [title]="detail.appointment_id">
                {{ detail.appointment_id || '-' }}
                <button class="copy-btn"
                        title="Copy appointment id"
                        (click)="copy(detail.appointment_id, 'Appointment ID')">
                  <i class="bi bi-clipboard"></i>
                </button>
              </span>
            </div>

            <div class="row-item" *ngIf="detail.lawyer?.name">
              <span class="row-label">Lawyer</span>
              <span class="row-value">{{ detail.lawyer?.name }}</span>
            </div>

            <div class="row-item" *ngIf="detail.amount">
              <span class="row-label">Amount</span>
              <span class="row-value">{{ money(detail.amount) }}</span>
            </div>

            <div class="row-item" *ngIf="detail.method">
              <span class="row-label">Payment Method</span>
              <span class="row-value">{{ modeLabel(detail.method) }}</span>
            </div>

          </div>
        </div>

        <button class="section-link section-link-btn"
                *ngIf="detail.order_id"
                (click)="viewRelatedPayment()">
          <i class="bi bi-eye"></i> View Related Payment
        </button>

        <button class="section-link section-link-btn"
                *ngIf="detail.appointment_id"
                (click)="viewRelatedAppointment()">
          <i class="bi bi-eye"></i> View Related Appointment
        </button>

      </div>

      <!-- Detail loading -->
      <div class="detail-body" *ngIf="detailLoading">
        <div class="skeleton-wrapper">
          <div class="skeleton-block" *ngFor="let block of [1,2,3,4]"></div>
        </div>
      </div>

      <!-- Detail unavailable -->
      <div class="detail-body" *ngIf="!detailLoading && !detail">
        <div class="empty-state">
          <i class="bi bi-exclamation-circle empty-icon"></i>
          <p class="empty-title">Details unavailable</p>
          <p class="empty-sub">This record could not be loaded.</p>
        </div>
      </div>

    </aside>

  </div>

</div>
